import { $q } from '@uirouter/core';
import * as angular from 'angular';
import { fabric } from 'fabric';
import { Group, StaticCanvas } from 'fabric/fabric-impl';

class CreateTemplateDialog implements ng.IController {
    public static $inject = [
        '$timeout'
    ];

    public textList = [
        'Bundle Deal',
        'Meal Deal',
        'MUST HAVE',
        'SAVER'
    ];
    public iconList = [
        'chilled-meats',
        'vape-liquids',
        'confectionary',
        'ready-meal',
        'beer-ale',
        'crisps',
        'fizzy-drink'
    ];
    public colorList = [
        '#189CD8',
        '#CD4B4D',
        '#F6B817',
        '#7EAC69'
    ];
    public selectedText: string;
    public selectedIcon: string;
    public selectedColor: string;
    public fabricCanvas: StaticCanvas;

    private svgPath = '/assets/images/bundles';
    private modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;
    private svgElementMap: Map<string, Group> = new Map<string, Group>();

    constructor(
        private $timeout: ng.ITimeoutService
    ) {
    }

    public async $onInit() {
        this.selectedText = this.textList[0];
        this.selectedIcon = this.iconList[0];
        this.selectedColor = this.colorList[0];
        this.$timeout(() => {
            this.prepareCanvas();
            this.redrawTemplate();
        }, 100);
    }

    public closeDialog() {
        this.modalInstance.dismiss();
    }

    public getIconSrcByName(filename: string): string {
        return `${this.svgPath}/icons/${filename}.svg`;
    }

    public async selectText(text: string) {
        if (this.selectedText === text) {
            return;
        }
        this.selectedText = text;
        await this.redrawTemplate();
    }

    public async selectIcon(icon: string) {
        if (this.selectedIcon === icon) {
            return;
        }
        this.selectedIcon = icon;
        await this.redrawTemplate();
    }

    public async selectColor(color: string) {
        if (this.selectedColor === color) {
            return;
        }
        this.selectedColor = color;
        await this.redrawTemplate();
    }

    public save() {
        const zoom = 1032 / this.fabricCanvas.getWidth();
        this.fabricCanvas.setWidth(1032);
        this.fabricCanvas.setHeight(516);
        this.fabricCanvas.setZoom(zoom);
        const data = this.fabricCanvas.toDataURL();
        this.modalInstance.close({ $value: data});
    }

    private async redrawTemplate() {
        this.fabricCanvas.clear();
        this.fabricCanvas.backgroundColor = this.selectedColor;
        const response = await $q.all({
            text: this.getTextImage(this.selectedText),
            icon: this.getIconImage(this.selectedIcon)
        });
        const textSvg = response.text;
        const iconSvg = response.icon;
        this.fabricCanvas.add(textSvg);
        textSvg.centerV();
        textSvg.left = 24;
        this.fabricCanvas.add(iconSvg);
        iconSvg.scale(2.5);
        iconSvg.centerV();
        iconSvg.originX = 'center';
        iconSvg.left = 190;
        this.fabricCanvas.renderAll();
    }

    private prepareCanvas() {
        this.fabricCanvas = new fabric.StaticCanvas('templateCanvas', {
            width: 240,
            height: 120,
            isDrawingMode: false
        });
    }

    private async getTextImage(name: string): Promise<Group> {
        return new Promise<Group>((resolve) => {
            if (this.svgElementMap.has(name)) {
                resolve(this.svgElementMap.get(name));
            } else {
                const fileName = this.selectedText.toLocaleLowerCase().replace(' ', '-');
                const path = `${this.svgPath}/texts/${fileName}.svg`;
                fabric.loadSVGFromURL(path, (objects) => {
                    const group = fabric.util.groupSVGElements(objects) as Group;
                    this.svgElementMap.set(name, group);
                    resolve(group);
                });
            }
        });
    }

    private async getIconImage(name: string): Promise<Group> {
        return new Promise<Group>((resolve) => {
            if (this.svgElementMap.has(name)) {
                resolve(this.svgElementMap.get(name));
            } else {
                const path = this.getIconSrcByName(name);
                fabric.loadSVGFromURL(path, (objects) => {
                    objects.forEach((val) => {
                        val.fill = 'white';
                    });
                    const group = fabric.util.groupSVGElements(objects) as Group;
                    this.svgElementMap.set(name, group);
                    resolve(group);
                });
            }
        });
    }
}

angular.module('naut').component('createTemplateDialog', {
    template: require('./create-template-dialog.component.html'),
    controller: CreateTemplateDialog,
    controllerAs: 'ctrl',
    bindings: {
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/bundles/components/create-template-dialog/create-template-dialog.component.ts